module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isApproved) ? _c('MentoringNewRequestForm', {
    on: {
      "submitRequestForm": _vm.emitRequestForm
    }
  }) : _c('Warning', [_c('template', {
    slot: "heading"
  }, [_vm._v("Обучающийся не подтвержден")]), _c('p', [_vm._v("Для включения человека в программу наставничества, пожалуйста,\nподтвердите его данные в учреждении доп. образования.")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f6d3046","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/newrequests/MentoringNewRequests.vue
// module id = b732aaa298dfd13fa893
// module chunks = 44